import Constants from '../actions/types';

const initialState = {
  permissions: [],
  loading: false,
  error: null
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.PERMISSIONS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.PERMISSIONS_GET_SUCCESS: {
      const newState = {
        ...state,
        permissions: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.PERMISSIONS_GET_FAILURE: {
      const newState = {
        ...state,
        permissions: [],
        error: action.payload,
        loading: false
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default permissionsReducer;
